/**
 * Topbar notification feeds.
 *
 * Three separate streams, as the ConceptDesign splits them:
 *   📢 本部からのお知らせ — pushed by 本部
 *   💻 システム通知      — generated by the system
 *   ☑  タスク一覧        — work assigned to me
 *
 * Fixture-level. Transcribed from ConceptDesigns/FCオーナー/consent-status.html;
 * the real feeds need notification tables that RA2N does not have yet.
 */

export interface NotificationItem {
  id: string;
  icon: string;
  title: string;
  /** Secondary line under the title. */
  meta?: string;
  /** Right-hand stamp — a relative time, a clock time or 本日 / 昨日. */
  time: string;
  /** Task urgency chip (`.task-pri`); tasks only. */
  priority?: 'urgent' | 'critical';
}

const HQ_ANNOUNCEMENTS: NotificationItem[] = [
  {
    id: 'hq-1',
    icon: '⚠',
    title: '10日内切迫: 利用者B (さくらST)',
    meta: '残10日 — 即時対応',
    time: '2h',
  },
  {
    id: 'hq-2',
    icon: '⚠',
    title: '20日内切迫: 利用者H · 利用者BS',
    meta: '残19日 / 残33日',
    time: '4h',
  },
  { id: 'hq-3', icon: '⚠', title: '切迫: 利用者B 残10日', meta: '自動アラート', time: '12:00' },
  { id: 'hq-4', icon: '⚠', title: '切迫: 利用者H 残19日', meta: '自動アラート', time: '12:00' },
];

const SYSTEM_NOTICES: NotificationItem[] = [
  { id: 'sys-1', icon: '🎂', title: '今月誕生日を迎える利用者が3名います', time: '本日' },
  { id: 'sys-2', icon: '📋', title: '同意書期限が20日以内の利用者が2名います', time: '本日' },
  { id: 'sys-3', icon: '💳', title: '保険証の有効期限が切れている利用者が1名います', time: '本日' },
  { id: 'sys-4', icon: '📑', title: '令和8年1月分の精算明細が確定しました', time: '昨日' },
];

const TASKS: NotificationItem[] = [
  {
    id: 'task-1',
    icon: '📷',
    title: '受信画像の確認 — 未確認 2件',
    meta: '撮影受領キュー · 施術者A / 施術者B より',
    time: '急ぎ',
    priority: 'urgent',
  },
  {
    id: 'task-2',
    icon: '↩',
    title: '再撮影依頼の対応待ち 2件',
    meta: '利用者F (ひまわりST) / 利用者E (すみれST)',
    time: '急ぎ',
    priority: 'urgent',
  },
];

export function getHqAnnouncements(): NotificationItem[] {
  return HQ_ANNOUNCEMENTS;
}

export function getSystemNotices(): NotificationItem[] {
  return SYSTEM_NOTICES;
}

export function getTasks(): NotificationItem[] {
  return TASKS;
}
